import React, { useEffect, useState } from "react";
import DiscussionItem from "./DiscussionItem";

function BBS() {
  const [discussions, setDiscussions] = useState([]);
  const [newDiscussion, setNewDiscussion] = useState({
    title: "",
    content: "",
  });

  // Fetch discussions from the server on mount
  useEffect(() => {
    // Replace this URL with your actual API endpoint
    fetch("http://localhost:3001/api/discussions")
      .then((res) => res.json())
      .then((data) => {
        // Assume the API returns a flat array of discussion objects
        // Build nested discussion structure
        console.log(data);
        const nested = buildNestedDiscussions(data);
        setDiscussions(nested);
      })
      .catch((error) => {
        console.error("Error fetching discussions:", error);
      });
  }, []);

  // Helper: Convert flat discussion list into a nested structure
  function buildNestedDiscussions(flatList) {
    console.log(flatList);
    const map = {};
    const roots = [];

    flatList.forEach((item) => {
      map[item.id] = { ...item, replies: [] };
    });

    flatList.forEach((item) => {
      if (item.parent_id) {
        if (map[item.parent_id]) {
          map[item.parent_id].replies.push(map[item.id]);
        }
      } else {
        roots.push(map[item.id]);
      }
    });

    console.log("roots", roots);
    return roots;
  }

  // Handle creating a new top-level discussion (simulate API call)
  const handleNewDiscussionSubmit = (e) => {
    e.preventDefault();
    if (newDiscussion.title.trim() && newDiscussion.content.trim()) {
      // In a real app, post data to your API and update state with response
      const newItem = {
        id: Date.now().toString(), // In production, use UUID from server
        parent_id: null,
        user_id: "fb238817-c019-4010-93e9-01d70f4dc3b2", // Replace with actual user ID
        title: newDiscussion.title,
        content: newDiscussion.content,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        replies: [],
      };

      //  Optionally, send a POST request to your API endpoint:
      fetch("http://localhost:3001/api/discussions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newItem),
      }).then((response) => response.json());

      // For now, we simulate it by updating local state
      setDiscussions((prev) => [newItem, ...prev]);
      setNewDiscussion({ title: "", content: "" });
    }
  };

  // Handle submitting a reply to an existing discussion (simulate API call)
  const handleReply = (parentId, replyContent) => {
    const newReply = {
      id: Date.now().toString(),
      parent_id: parentId,
      user_id: "CurrentUser", // Replace with actual user ID
      title: "", // Replies might not have a title
      content: replyContent,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      replies: [],
    };

    // In a real app, send a POST request to create the reply on the server

    // Update the local state recursively to add the new reply
    const updateReplies = (list) =>
      list.map((item) => {
        if (item.id === parentId) {
          return { ...item, replies: [...item.replies, newReply] };
        } else if (item.replies && item.replies.length > 0) {
          return { ...item, replies: updateReplies(item.replies) };
        }
        return item;
      });

    setDiscussions((prev) => updateReplies(prev));
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto" }}>
      {/* Form to create a new discussion */}
      <form
        onSubmit={handleNewDiscussionSubmit}
        style={{ marginBottom: "20px" }}
      >
        <input
          type="text"
          placeholder="Discussion Title"
          value={newDiscussion.title}
          onChange={(e) =>
            setNewDiscussion({ ...newDiscussion, title: e.target.value })
          }
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <textarea
          placeholder="Discussion Content"
          value={newDiscussion.content}
          onChange={(e) =>
            setNewDiscussion({ ...newDiscussion, content: e.target.value })
          }
          rows="4"
          style={{ width: "100%", padding: "8px" }}
        />
        <button type="submit" style={{ marginTop: "10px" }}>
          Create Discussion
        </button>
      </form>

      <hr />

      {/* Render fetched discussions */}
      <div>
        {discussions.map((discussion) => (
          <DiscussionItem
            key={discussion.id}
            discussion={discussion}
            onReply={handleReply}
          />
        ))}
      </div>
    </div>
  );
}

export default BBS;
